import { IFilter } from '../../types'
import * as React from 'react'

interface IFilterItem {
  handleSelect: (id: string, name: string) => any
  data: IFilter[]
}

const FilterItem = (props: IFilterItem) => {
  return (
    <div>
      {props.data.map((it: IFilter) => (
        <div className='p2' key={it.id}>
          <div className='uppercase font-grey3 h6 bold'>{it.title}</div>
          {it.params.map((option: string, key: number) => (
            <div className='mt1 flex items-center' key={`${it.id}${key}`}>
              <input type='checkbox' onChange={props.handleSelect(it.id, option)} />
              <span className='pl1 h6 font-dark-grey'>{option}</span>
            </div>
          ))}
        </div>
      ))}
    </div>
  )
}

export default FilterItem



// WEBPACK FOOTER //
// ./src/components/vehicles/FilterItem.tsx